import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Table } from '@quintoandar-tokko/jopijs';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';
import { getPerformanceConversionTimeTable } from '@/store/slices/components/dashboard/service';
import buildQuery from '../../utils/buildQuery';
import buildTableQuery from '../../utils/buildTableQuery';
import useObserver from '@/hooks/useObserver';
import ConversionTimeTableRow from './ConversionTimeTableRow';

export default function ConversionTimeNonGroupedTableContent({ headers }) {
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const dispatch = useDispatch();
  const { conversionTime } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const { ref: loadMoreRef, isInViewport } = useObserver();

  useEffect(() => {
    if (!conversionTime.has_next) return;
    if (!isInViewport || conversionTime.loading) return;

    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(conversionTime, {
      withNextPage: true,
    });

    dispatch(getPerformanceConversionTimeTable({ query, tableQuery }));
  }, [isInViewport]);

  return (
    <Table.Rows>
      {conversionTime.list.map((row, index) => (
        // eslint-disable-next-line
        <ConversionTimeTableRow key={index} row={row} />
      ))}

      <Box as="tr" ref={loadMoreRef} style={{ height: 1, opacity: 0 }} />

      {(conversionTime.loading || conversionTime.has_next) && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
